export default "__VITE_ASSET__c683a047__"